const GA_EVENTS = {
  INTERNAL_ROUTING: 'Internal routing',
  USER_INTERACTION: 'User interaction',
  SCROLL: 'Scroll',
};

export default GA_EVENTS;
